import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('article-mediacenter', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./article-mediacenter')
    ),
);
